module.exports = __webpack_public_path__ + "img/zj_hover.c20a7139.png";